import { useEffect, useRef, useState } from "react";
import { AttributeFieldProps } from "./RenderAttributeInput";
import  { AttributeTargetType } from "../Data/WBData";
import {  FilterDropDown, MapFilterOptions } from "../Menus/FilterDropdowns";
import SelectDropdown from "../SelectDropdown";
import { GetBlogAuthors, GetBlogTagsOrCategories } from "vagaro-website-rendering/src/components/Utilities/BlogAPI";
import { BlogChipData } from "../Menus/BlogSettingsPopup";
import LayoutNode, { getNodeComponentAttributeValue } from "vagaro-website-rendering/src/components/Definitions/LayoutNode";
import { BlogFilterData, BlogSortType, GetBlogFilterDataFromString } from "vagaro-website-rendering/src/components/BusinessControls/RenderBlogList";

const SortOptions = [
  {label:"None",value:""},
  {label:"Newest",value:BlogSortType.Newest},
  {label:"Oldest",value:BlogSortType.Oldest},
  {label:"Title A-Z",value:BlogSortType.TitleAZ},
  {label:"Title Z-A",value:BlogSortType.TitleZA},
  {label:"Author A-Z",value:BlogSortType.AuthorAZ},
  {label:"Author Z-A",value:BlogSortType.AuthorZA},

]


const limitOptions = [
  {label:"None",value:"1000"},
  {label:"1",value:"1"},
  {label:"2",value:"2"},
  {label:"3",value:"3"},
  {label:"4",value:"4"},
  {label:"5",value:"5"},
  {label:"6",value:"6"},
  {label:"7",value:"7"},
  {label:"8",value:"8"},
  {label:"9",value:"9"},
  {label:"10",value:"10"},
  {label:"11",value:"11"},
  {label:"12",value:"12"},
]


export default function BlogFilterField({label,definition,layoutObject,updateFunc,screenSize,saveFunc,siteData}:AttributeFieldProps){


    const [filteredCats,setFilteredCats] = useState<string[]>([]);
    const [filteredTags,setFilteredTags] = useState<string[]>([]);
    const [filteredAuthors,setFilteredAuthors] = useState<string[]>([]);
    const [limit,setLimit] = useState<number>(1000);
    const [sortType,setSortType] = useState<string>("");


    const [categories,setAllCats] = useState<BlogChipData[]>([]);
    const [tags,setAllTags] = useState<BlogChipData[]>([]);
    const [authors,setAllAuthors] = useState<BlogChipData[]>([]);

    const firstLoadRef = useRef(true);

    const loadRef = useRef(0);

    useEffect(()=>{

      let filterStr = getNodeComponentAttributeValue (layoutObject, "blog-filter", "")
      let filter = GetBlogFilterDataFromString(filterStr);

      setFilteredCats(filter.cat);
      setFilteredTags(filter.tag);
      setFilteredAuthors(filter.authors);
      setLimit(filter.limit);
      setSortType(filter.sort);

      const OnLoaded = ()=>{
        loadRef.current++;
        if(loadRef.current>=3){
          firstLoadRef.current = false;
        } 
      }

      GetBlogTagsOrCategories(true,siteData.userContext,(data)=>{
        setAllTags(data.sort((a:any,b:any)=>a.name.localeCompare(b.name)));
       OnLoaded();
      },(data)=>{ });

      GetBlogTagsOrCategories(false,siteData.userContext,(data)=>{
        setAllCats(data.sort((a:any,b:any)=>a.name.localeCompare(b.name)));
        OnLoaded();
      },(data)=>{ });

      GetBlogAuthors(siteData.userContext,(data)=>{
        if(data?.data?.data)
        setAllAuthors(data.data.data.map((d:any)=>{return {id:d.encUserID,name:d.firstName+" "+d.lastName}}));
        OnLoaded();
      },(data)=>{ });
//eslint-disable-next-line
    },[]);

    useEffect(()=>{
      if(!firstLoadRef.current){

        let filterObj:BlogFilterData = {search:"",cat:filteredCats,tag:filteredTags,authors:filteredAuthors,limit:limit,sort:sortType};

        updateFunc("blog-filter", encodeURIComponent( JSON.stringify(filterObj)),AttributeTargetType.Component);
        (layoutObject as LayoutNode).data = null;
        (layoutObject as LayoutNode).forceUpdate();
        saveFunc();
      }

      //eslint-disable-next-line
    },[filteredCats,filteredTags,filteredAuthors,limit,sortType]);

    return (
      <div className="wb-input-group" >
         
        <FilterDropDown label={"Filter Categories"} displayValue={filteredCats.length>0?`${filteredCats.length} Selected`:"None"} updated={false} >
          
          <MapFilterOptions wording="Categories" allOptions={categories} selectedOptions={filteredCats} updateSelected={setFilteredCats} />
        </FilterDropDown>
      <br/>
        <FilterDropDown label={"Filter Tags"} displayValue={filteredTags.length>0?`${filteredTags.length} Selected`:"None"} updated={false} >
          <MapFilterOptions wording="Tags" allOptions={tags} selectedOptions={filteredTags} updateSelected={setFilteredTags} />
        </FilterDropDown>
        <br/>
        <FilterDropDown label={"Filter Author"} displayValue={filteredAuthors.length>0?`${filteredAuthors.length} Selected`:"None"} updated={false} >
          <MapFilterOptions wording="Authors" allOptions={authors} selectedOptions={filteredAuthors} updateSelected={setFilteredAuthors} />
        </FilterDropDown>
        <br/>
        <div className="flex-row justify-between w-full " >
          <label>Sort</label>
          <SelectDropdown  options={SortOptions} key={loadRef.current} defaultValue={sortType} onChange={(val:string)=>{
            setSortType(val);
          }} />
          </div>
          <br/>
        <div className="flex-row justify-between w-full " >
          <label>Limit Results</label>
          <SelectDropdown  options={limitOptions} key={loadRef.current} defaultValue={limit.toString()} onChange={(val:string)=>{
            setLimit(parseInt(val));
          }} />
          </div>
          {/* <br/>
          <div className="flex-row justify-between w-full " >
            
          <label>Sort</label>
          <SelectDropdown options={[{label:"None",value:"1000"}]} defaultValue={""} onChange={()=>{}} />
          </div> */}
      </div>
    );

}

